import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import NewspaperIcon from '@mui/icons-material/Newspaper';

export const warehouseNotifications = {
    all:  {
        title: 'notifications',
        icon: <ChecklistOutlinedIcon/>,
        isSingleDataGrid: true,
    },
    news:  {
        title: 'news',
        icon: <NewspaperIcon/>,
    },
    notificationsettings:  {
        title: 'notificationsettings',
        // position:'right',
        icon: <ChecklistOutlinedIcon/>,
        isSingleDataGrid: true,
    },
};
